<template>
    <div>
        <div class="box">
            <div class="text-box">
                <p class="first-text">Resetare parola</p>
                <b-alert v-if="requestError" show variant="danger" class="d-flex justify-content-between align-items-center">
                    <small>{{ requestError }}</small>
                    <b-icon-exclamation-triangle variant="danger" font-scale="1.5"></b-icon-exclamation-triangle>
                </b-alert>   
            </div>
            <div>
                <validation-observer #default="{ invalid }">
                    <b-form @submit.prevent="send()">
                        <b-form-group
                            id="password-group"
                            label="Parolă"
                            label-for="password"
                            class="w-100 position-relative"
                        >    
                            <b-form-group>
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                    name="password"
                                >
                                    <b-form-input 
                                        id="password" 
                                        v-model="form.password" 
                                        :state="errors.length > 0 ? false : null" 
                                        :type="passwordFieldType" 
                                        placeholder="**********"
                                        class="w-100"
                                    ></b-form-input>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                                <span
                                    v-if="errors.has('password')"
                                    class="error-message"
                                    v-text="errors.get('password')"
                                ></span>
                            </b-form-group>
                            <span
                                v-if="form.password.length != 0"
                                toggle="#password-field"
                                class="fa fa-fw fa-eye field-icon toggle-password"
                                @click="switchVisibility(1)"
                            ></span>
                        </b-form-group>
                        <b-form-group
                            id="confirm-password-group"
                            label="Confirmă Parolă "
                            label-for="confirm-password"
                            class="w-100 position-relative"
                        >    <b-form-group>
                                 <validation-provider
                                     #default="{ errors }"
                                     rules="required"
                                     name="confirm-password"
                                 >
                                     <b-form-input 
                                         id="confirm-password" 
                                         v-model="form.password_confirmation" 
                                         :type="passwordConfirmFieldType" 
                                         placeholder="**********" 
                                         :state="errors.length > 0 ? false : null" 
                                         class="w-100"
                                     ></b-form-input>
                                     <small class="text-danger">{{ errors[0] }}</small>
                                 </validation-provider>
                                 <span
                                     v-if="errors.has('confirm-password')"
                                     class="error-message"
                                     v-text="errors.get('confirm-password')"
                                 ></span>
                             </b-form-group>
                            <span
                                v-if="form.password_confirmation.length > 0"
                                toggle="#password-field"
                                class="fa fa-fw fa-eye field-icon toggle-password"
                                @click="switchVisibility(2)"
                            ></span>
                        </b-form-group>
                        <div class="w-100">
                            <b-button
                                type="submit"
                                variant="primary"
                                block
                                :disabled="invalid"
                            >Resetare Parola
                            </b-button>
                        </div>
                    </b-form>
                </validation-observer >
                <div class="logare">
                    <p class="logare">
                        <router-link class="text-blue" to="/login"> &lt; Logare </router-link>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { BForm,BFormGroup,BFormInput,BButton,BAlert,BIconExclamationTriangle} from 'bootstrap-vue';
    import api from '@/helpers/api'
    import axios from '@/helpers/axios'
    import { startSession } from '@/helpers/auth'
    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    require('@/helpers/validations/validations');
    import Errors from '@/helpers/Errors';
    export default {
        name: "PasswordResetForm",
        components: { 
            BForm,
            BFormGroup,
            BFormInput,
            BButton ,
            ValidationProvider,
            ValidationObserver,
            BAlert,
            BIconExclamationTriangle
        },
        props: {},
        data() {
            return {
                form:{
                    password:'',
                    password_confirmation:'',
                    email:'',
                    token:'',
                },
                passwordFieldType:'password',
                passwordConfirmFieldType:'password',
                errors: new Errors(),
                requestError:null,
            };
        },
        created() {},
        methods: {
            send() {
                this.$store.dispatch('auth/logout').then(() => {
                    startSession().then(() => {
                        let config = {
                            headers: {
                                'form-origin': 'm3'
                            }
                        }
                        this.form.email = this.$route.query.email;
                        this.form.token = this.$route.params.pathMatch;
                        axios.post(api.API_ENDPOINTS.resetPassword, this.form, config)
                            .then(response => {
                                this.$toast.success(response.data.message);
                                this.$router.push({ path: api.LOGIN_ROUTE });   
                            })
                            .catch(xhr => {
                                if(xhr.response.data && xhr.response.data.errors && xhr.response.data.errors.email && xhr.response.data.errors.email.length>0){
                                    this.requestError = xhr.response.data.errors.email[0];
                                }
                                this.$toast.error(xhr.response.data.message);
                            })
                    })
                });
                
            },
            switchVisibility(type) {
                switch (type){
                case 1:
                    this.passwordFieldType =  this.passwordFieldType==="password" ? "text" : "password";
                    break;
                case 2:
                    this.passwordConfirmFieldType =  this.passwordConfirmFieldType==="password" ? "text" : "password";
                    break            
                }               
                    
            },
        },
    };
</script>

<style scoped>
	.box {
		display: flex;
		flex-direction: column;
		padding: 0 40px;
	}
	.text-box {
		margin-bottom: 20px;
	}
	form {
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	label {
		margin-bottom: 2px;
		font-size: 14px;
		color: #818181;
	}
	input:not([type="checkbox"]) {
		margin-bottom: 10px;
		width: initial;
		line-height: 30px;
		border-radius: 5px;
		border: 1px solid #e7e1e7;
		padding-left: 10px;
		color: #818181;
	}
	input:focus {
		outline: none !important;
		border: 1px solid #6793ce;
	}
	input::placeholder {
		color: #cac5d4;
	}
	.first-text {
		font-size: 22px;
		font-weight: 600;
		background: -webkit-linear-gradient(#262728, #4e5359);
		background-clip: text;
		-webkit-text-fill-color: transparent;
		text-align: left;
		margin: 30px 0 20px 0;
	}
	.form-field {
		display: flex;
		position: relative;
		flex-direction: column;
		width: 100%;
	}
	.checkbox-field {
		display: flex;
		flex-direction: row;
		margin-right: auto;
		align-items: center;
	}
	.buton-register {
		margin-top: 15px;
	}
	.logo-mic {
		position: absolute;
		bottom: 40px;
		right: 50px;
	}
	.logare {
		text-align: center;
		margin-top: 20px;
	}
	.text-blue {
		color: #4d87f1;
	}
    .field-icon {
		position: absolute;
		z-index: 2;
		cursor: pointer;
        right: 15px;
        top: 43px;
	}

</style>
